import React from "react";
import Calendar from "./Calendar";
import { getSmallest, getPriceRank, getIntentByDate } from "./Main";

const MiniDay = ({
	date,
	monthIndex,
	searchIntents,
	priceRange,
	tripType,
	goIntent,
	backIntent
}) => {
	let modifier = "";
	const dateData =
		tripType === "RT"
			? getIntentByDate(date, searchIntents, true)
			: getIntentByDate(date, searchIntents);

	if (monthIndex === null) modifier = "other-month";
	else if (!dateData) modifier = "disabled";
	else if (date === goIntent || date === backIntent) {
		modifier = "selected";
	} else {
		const price = getSmallest(dateData);
		const rank = getPriceRank(price, priceRange);
		modifier = `rank-${rank}`;
	}

	return <div className={`mini-calendar__day mini-calendar__day--${modifier}`} />;
};

class MiniCalendar extends Calendar {
	constructor(props) {
		super(props);

		this.renderDay = this.renderDay.bind(this);
	}

	renderDay(props) {
		return <MiniDay {...props} />;
	}

	render() {
		const onClick = () => this.props.goToMonth(this.props.month);

		return (
			<div className="mini-calendar" onClick={onClick}>
				<h4 className="mini-calendar__header">{this.getName()}</h4>
				<div className="mini-calendar__day-group">{this.renderDays()}</div>
			</div>
		);
	}
}

export default MiniCalendar;
